import styles from "./Popup.module.css";
import { Box, Button, Checkbox, Chip, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Check } from "react-feather";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default function AssignDeliveryDriverPopup({ setFormOpen, selectedDriverList, setSelectedDriverList, setLoading, driverList }) {

  return (<>
    <DialogTitle id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
      Assign Booking Details To Driver
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} ><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <div className={`${styles.FormMainRow}`}>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Driver</InputLabel>
            <Select
              label="Select Driver"
              multiple
              value={selectedDriverList}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedDriverList(typeof value === 'string' ? value.split(',').map(Number) : value);
              }}
              input={<OutlinedInput id="select-multiple-chip" label="People" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((id) => {
                    const person = driverList.find((p) => p.id === id);
                    return <Chip key={id} label={person?.name || id} />;
                  })}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {driverList?.map((i) => {
                return (<MenuItem key={i?.id} value={i?.id}>
                  <Checkbox checked={selectedDriverList.includes(i?.id)} />
                  <ListItemText primary={i?.name} />
                </MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} onClick={(e) => setFormOpen(false)}>Assign</Button>
        </div>
      </div>
    </DialogContent>
  </>);
}